import {useEffect} from 'react';

/**
 * This hoook use dynamic imports to import all necessary modules to be able to render graphical signature
 */
export default function useInitializeGraphicalSignature() {
    useEffect(() => {
        Promise.all([
            import(/* webpackChunkName: "signature-utils" */ '../../AccountSettings/CaptureSignature/utils/signaturePad/signaturePad'),
            import(/* webpackChunkName: "signature-utils" */ 'jsignature/libs/jSignature.min')
        ]);
    }, []);
}
